<template>
  <div class="vip-pop" >
    <van-popup
      v-model="show"
      :close-on-click-overlay="false"
      round
    >
      <div class="vip-wrap">
        <div class="title"> {{ changeSucc ? '兑换成功！' : '确认兑换'  }} </div>
        <div class="consume diandiandian-multiple" v-if="!changeSucc">本次兑换将消耗【{{ info.defaultPoolName }}】* 1，确认兑换吗？</div>
        <div class="left_benefit">
          <div class="left_info">
            <img src="https://coolcdn.igetcool.com/p/2024/3/0d2726ce782df0e94f3d5ad0ffea6638.png?_128x128.png" alt="">
            <div class="left_corse">
              <p style="font-size: 14px;" v-for="(item, index) in info.allExchangeDetail" :key="index">{{ item.poolName }}：剩余<span>{{ item.canChangeCount }}</span>次</p>
              <!-- <p>99元课程：剩余<span>2</span>次</p> -->
            </div>
          </div>
        </div>

        <div class="vip-btn">
          <div v-if="changeSucc" class="sure" style="width: 100%;" @click="goCourse">去学习</div>
          <template v-else>
            <div class="cancel" @click="canle">取消</div>
            <div class="sure" @click="sureChange">兑换</div>
          </template>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
/**
 * vip兑换权益弹窗
 */

export default {
  name: 'vipBenefits',
  props: {
    show: {
      type: Boolean,
      default: () => { false }
    },
    info: {
      type: Object,
      default: () => { {} }
    },
    changeSucc: {
      type: Boolean,
      default: () => { false }
    }
  },
  created() {
  },
  data() {
    return {
    };
  },
  methods: {
    canle() {
      this.$emit('closePop');
    },
    // 确认兑换
    sureChange() {
      this.$emit('sureChange');
    },
    // 去学习
    goCourse() {
      this.$emit('goCourse');
    }
  },
};
</script>

<style lang="stylus" scoped>
.vip-pop {
  .vip-wrap {
    width 295px;
    background url('https://coolcdn.igetcool.com/p/2024/3/bc0f1bc4c53c027f04eac78011a1abdf.png?_590x136.png') no-repeat center top;
    background-size 100% 68px;
    box-sizing border-box;
    padding 20px;
    .title {
      color: #41414D
      font-size 20px;
      fonw-weight bold;
      text-align center;
      line-height 24px;
      margin 10px 0;
    }

    .consume {
      font-size 16px;
      color: #6D6D80;
      text-align center;
      line-height 20px;
    }

    .left_benefit {
      width: 247px;
      background: url('../images/study-card.png') no-repeat center top #FFF4E0;
      background-size 114px 24px;
      height 100px;
      border-radius 12px;
      margin 16px auto;
      overflow hidden
      .left_info {
        display flex;
        margin-top 24px;
        align-items center;
        img {
          width 64px
          margin-left 15px;
          margin-right 5px;
        }
        p {
          color #6D6D80;
          line-height 20px;
          span {
            color: #FF5F2E;
            fons-size 14px;
          }
        }
      }
    }

    .vip-btn {
      display flex;
      justify-content space-between;
      margin-bottom 10px;
      div {
        width 120px;
        height 50px;
        box-sizing border-box;
        text-align center;
        line-height 50px;
        border-radius 25px;
        fons-size 16px;
        fonw-weight 500;
      }
      .cancel {
        border 1px solid #C2C2CC
        color: #6D6D80;
      }
      .sure {
        background: #FF5E2E;
        color: #fff;
      }
    }
  }
}
</style>
